/******/ (() => {
var __webpack_exports__ = {};
window.PXUTheme.jsCustomCollectionCarousel = {
  MOBILE_BREAKPOINT: 798,

  init($section) {
    const sectionData = window.PXUTheme.getSectionData($section);

    window.PXUTheme.jsCustomCollectionCarousel = $.extend(
      this,
      sectionData,
    );

    $section.data('customCollectionCarouselSettings', sectionData);

    this.unload($section);
    this.initSliders($section, sectionData);

    const sectionId = $section.attr('id');
    const namespace = `customCollectionCarousel-${sectionId}`;

    const onResize = () => {
      clearTimeout(this._resizeTimers[sectionId]);
      this._resizeTimers[sectionId] = setTimeout(() => {
        this.resizeVisibleSliders($section);
      }, 150);
    };

    $(window).on(`resize.${namespace}`, onResize);

    const mq = window.matchMedia(`(max-width: ${this.MOBILE_BREAKPOINT}px)`);
    const onBreakpointChange = () => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.destroySliders($section);
          this.initSliders($section, $section.data('customCollectionCarouselSettings'));
        }, 50);
      });
    };

    mq.addEventListener('change', onBreakpointChange);
    $section.data('customCollectionCarouselMq', mq);
    $section.data('customCollectionCarouselMqHandler', onBreakpointChange);
  },

  getSliderConfigs(settings) {
    const configs = [];

    if (settings.mobile_layout === 'slider') {
      configs.push({
        wrapperSelector: '[data-custom-collection-carousel="mobile"]',
        prevSelector: '.custom-collection-carousel__nav--mobile-prev',
        nextSelector: '.custom-collection-carousel__nav--mobile-next',
        showArrows: settings.show_arrows_mobile,
        showDots: settings.show_navigation_dots_mobile,
      });
    }

    if (settings.desktop_layout === 'slider') {
      configs.push({
        wrapperSelector: '[data-custom-collection-carousel="desktop"]',
        prevSelector: '.custom-collection-carousel__nav--desktop-prev',
        nextSelector: '.custom-collection-carousel__nav--desktop-next',
        showArrows: settings.show_arrows_desktop,
        showDots: settings.show_navigation_dots_desktop,
      });
    }

    return configs;
  },

  initSliders($section, settings) {
    this.getSliderConfigs(settings).forEach((config) => {
      this.createSlider(
        $section,
        config.wrapperSelector,
        config.prevSelector,
        config.nextSelector,
        config.showArrows,
        config.showDots,
      );
    });
  },

  isVisible($wrapper) {
    if (!$wrapper.length) return false;
    return $wrapper[0].getBoundingClientRect().width > 0;
  },

  createSlider($section, wrapperSelector, prevSelector, nextSelector, showArrows, showDots) {
    const $wrapper = $section.find(wrapperSelector);
    if (!this.isVisible($wrapper) || $wrapper.hasClass('flickity-enabled')) return;

    const $prevButton = $section.find(prevSelector);
    const $nextButton = $section.find(nextSelector);

    const $flickitySlider = $wrapper.flickity({
      initialIndex: 0,
      prevNextButtons: false,
      wrapAround: false,
      pageDots: showDots,
      watchCSS: false,
      imagesLoaded: true,
      cellAlign: 'left',
      contain: true,
      adaptiveHeight: true,
      freeScroll: false,
      draggable: true,
    });

    const updateArrowState = () => {
      if (!showArrows) return;

      const flickity = $wrapper.data('flickity');
      if (!flickity || !flickity.cells.length) return;

      const scrollOffset = Math.abs(flickity.x);
      const viewportWidth = flickity.size.innerWidth;
      const lastCell = flickity.cells[flickity.cells.length - 1];
      const contentWidth = lastCell.target + lastCell.size.outerWidth;
      const maxScroll = Math.max(0, contentWidth - viewportWidth);
      const canScroll = maxScroll > 1;

      if (!canScroll) {
        $prevButton.prop('disabled', true).addClass('is-disabled');
        $nextButton.prop('disabled', true).addClass('is-disabled');
        return;
      }

      const atStart = scrollOffset <= 1;
      const atEnd = scrollOffset >= maxScroll - 2;

      $prevButton.prop('disabled', atStart).toggleClass('is-disabled', atStart);
      $nextButton.prop('disabled', atEnd).toggleClass('is-disabled', atEnd);
    };

    $wrapper.data('updateArrowState', updateArrowState);

    const resizeSlider = () => {
      if ($wrapper.hasClass('flickity-enabled')) {
        $wrapper.flickity('resize');
        updateArrowState();
      }
    };

    $flickitySlider.on('change.flickity settle.flickity scroll.flickity select.flickity dragEnd.flickity', updateArrowState);
    $wrapper.on('ready.flickity', () => {
      resizeSlider();
      updateArrowState();
    });

    if (showArrows) {
      $prevButton.on('click', (event) => {
        if ($prevButton.prop('disabled')) {
          event.preventDefault();
          return;
        }
        $flickitySlider.flickity('previous');
      });
      $nextButton.on('click', (event) => {
        if ($nextButton.prop('disabled')) {
          event.preventDefault();
          return;
        }
        $flickitySlider.flickity('next');
      });
    }

    setTimeout(() => {
      resizeSlider();
      updateArrowState();
    }, 100);
  },

  resizeVisibleSliders($section) {
    $section.find('[data-custom-collection-carousel]').each(function () {
      const $wrapper = $(this);

      if ($wrapper[0].getBoundingClientRect().width > 0 && $wrapper.hasClass('flickity-enabled')) {
        $wrapper.flickity('resize');

        const updateArrowState = $wrapper.data('updateArrowState');
        if (updateArrowState) updateArrowState();
      }
    });
  },

  destroySliders($section) {
    $section.find('.flickity-enabled').flickity('destroy');
    $section.find('.custom-collection-carousel__nav-button').off('click');
    $section.find('[data-custom-collection-carousel]').removeData('updateArrowState');
  },

  unload($section) {
    const sectionId = $section.attr('id');
    const namespace = `customCollectionCarousel-${sectionId}`;

    $(window).off(`resize.${namespace}`);

    if (this._resizeTimers && this._resizeTimers[sectionId]) {
      clearTimeout(this._resizeTimers[sectionId]);
    }

    const mq = $section.data('customCollectionCarouselMq');
    const handler = $section.data('customCollectionCarouselMqHandler');

    if (mq && handler) {
      mq.removeEventListener('change', handler);
    }

    $section.removeData('customCollectionCarouselMq');
    $section.removeData('customCollectionCarouselMqHandler');

    this.destroySliders($section);
  },

  _resizeTimers: {},
};

/******/ })();
